class PdpRecommendations extends HTMLElement {
  connectedCallback () {
    this.container = this
    this.productId = this.dataset.productId
    this.renderMode = this.dataset.render || 'carousel'
    if (!this.productId) return
    this.root = this.closest('[data-recommendations-root]')
    this.fetchAndRender(this.productId)
  }

  async fetchAndRender (productId) {
    try {
      const basePath = (window?.Shopify?.routes?.root || '/')
      const sectionId = this.dataset.sectionId || (this.dataset.atcButtons === 'true' ? 'product-recommendations-with-atc' : 'product-recommendations')
      const intent = this.dataset.intent || 'complementary'
      const url = `${basePath}recommendations/products?section_id=${sectionId}&product_id=${encodeURIComponent(productId)}&limit=10&intent=${encodeURIComponent(intent)}`
      const res = await fetch(url, { credentials: 'same-origin' })
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      const html = await res.text()
      const temp = document.createElement('div')
      temp.innerHTML = html
      const grid = temp.querySelector('[data-product-recommendations]') || temp
      const cards = grid.querySelectorAll('a.product-card, [data-product-card]')
      if (cards.length === 0) {
        if (this.root) this.root.classList.add('hidden')
        this.innerHTML = ''
        this.removeDotsSkeleton()
        return
      }
      const isGrid = this.renderMode === 'grid'
      const renderedHtml = Array.from(cards).map((card) => {
        if (isGrid) {
          const clonedCard = card.cloneNode(true)
          return clonedCard.outerHTML
        }
        const slideClass = this.dataset.slideClass || 'products-from-collection__carousel-slide products-from-collection-carousel__slide select-none'
        const slide = document.createElement('div')
        slide.className = slideClass
        slide.appendChild(card.cloneNode(true))
        return slide.outerHTML
      }).join('')
      this.innerHTML = renderedHtml
      this.removeDotsSkeleton()
      window.dispatchEvent(new CustomEvent('pdp:recommendations:loaded', { detail: { productId, count: cards.length } }))
    } catch (e) {
      console.error('[PdpRecommendations] fetch error', e)
      this.innerHTML = ''
      this.removeDotsSkeleton()
      if (this.root) this.root.classList.add('hidden')
    }
  }

  removeDotsSkeleton () {
    const skeleton = this.root ? this.root.querySelector('[data-dots-skeleton]') : null
    if (skeleton) skeleton.remove()
  }
}

if (!customElements.get('pdp-recommendations')) {
  customElements.define('pdp-recommendations', PdpRecommendations)
}
